import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/auth";
import { useNavigate } from "react-router";
import axios from "axios";

import Header from "../../components/header";
import OrderBar from "../../components/orderBar";
import { PuffLoader } from "react-spinners";
import "./style.css";

const Neaktivne = () => {
  const navigate = useNavigate();
  const { isAuthenticated, logout } = useContext(AuthContext);
  const [aktivnost, setAktivnost] = useState(true);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Set default dates: one month ago to now
  const getDefaultStartDate = () => {
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
    return oneMonthAgo.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };

  const getDefaultEndDate = () => {
    return new Date().toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };

  const [startDate, setStartDate] = useState(getDefaultStartDate());
  const [endDate, setEndDate] = useState(getDefaultEndDate());

  const aktivnostChange = async (orderId) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/admin/change-order-activity`,
        {
          orderId,
        }
      );
      setOrders((prevData) => prevData.filter((order) => order.id !== orderId));
    } catch (err) {
      logout();
    }
  };

  const getAndSetOrders = async () => {
    try {
      setLoading(true);

      // Convert date strings to ISO strings for the API
      const startDateISO = startDate ? new Date(startDate).toISOString() : null;
      const endDateISO = endDate
        ? new Date(endDate + "T23:59:59").toISOString()
        : null;

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/admin/get-inactive-orders`,
        {
          startDate: startDateISO,
          endDate: endDateISO,
        }
      );

      setOrders(response.data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Initial fetch on mount with default dates
    getAndSetOrders();
  }, []);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated]);

  return (
    <div className="page-container">
      <Header />

      <div className="page-content">
        <div className="date-input-container">
          <div className="date-input-wrapper">
            <label className="date-input-label">Od:</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => {
                setStartDate(e.target.value);
              }}
              className="date-input"
            />
          </div>

          <div className="date-input-wrapper">
            <label className="date-input-label">Do:</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => {
                setEndDate(e.target.value);
              }}
              className="date-input"
            />
          </div>

          <button
            onClick={getAndSetOrders}
            className="date-search-btn"
            disabled={loading}
          >
            {loading ? "Pretraži..." : "Pretraži"}
          </button>
        </div>

        <div className="home-orders-div">
          {loading ? (
            <PuffLoader size={50} color={"#031623"} />
          ) : (
            [...(orders || [])].reverse().map((order, index) => {
              return (
                <OrderBar
                  aktivnostChange={aktivnostChange}
                  key={index}
                  order={order}
                />
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};

export default Neaktivne;
